import { PAYMENT_BASE_URL } from "../../../constants";

export const WITHDRAWS_BASE_URL = `${PAYMENT_BASE_URL}withdrawal`;
